module.exports = __webpack_public_path__ + "img/food.ffb603ee.jpg";